module.exports = __webpack_public_path__ + "static/img/3-design-b4.7b5233b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-design-b4.jpg
// module id = ZtUs
// module chunks = 0